import { styled } from "@mui/system";

export const StyledCompanyDetailsWrapper = styled("div")({
  width: "100%",
  fontSize: "1rem",
  lineHeight: 1.33,
  color: "#86868b",
  height: "60px",
  wordBreak: "break-word",
  "&.companyNameColumn": {
    height: "auto"
  }
});

export const StyledTitle = styled("h4")(({ theme }) => ({
  marginTop: "0px",
  color: "#373737",
  fontSize: "15px",
  alignItems: "center",
  fontWeight: "600"
}));

export const StyledErrorMsg = styled("div")(({ theme }) => ({
  fontWeight: 600,
  fontSize: "20px",
  marginBottom: "24px"
}));
